export enum AlarmStatus {
  Disabled  = 0,
  Enabled  = 1,
}